import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import {getNodeFileGroups} from "api/services/node-service";
import {useCallback} from "react";
import {IGetNodeFileGroupsRequest} from "api/models/request/IGetNodeFileGroupsRequest";
import {NodeFileType} from "@models/NodeFileType";

export const useGetNodeFileGroups = () => {
    const {callAPI, loading} = useWorkspaceApiCall<IGetNodeFileGroupsRequest, string[]>(getNodeFileGroups, '', 'getNodeFileGroups.error');

    const fetchNodeFileGroups = useCallback(async (editor: any, nodeFileType: NodeFileType) => {
        const response = await callAPI({nodeFileType});

        if(response?.success) {
            editor.storage.setNodeFileGroups(nodeFileType, response.data);
        }

        return response;
    }, [callAPI])

    return {fetchNodeFileGroups, isLoading: loading};
}